export const relativeCoordinates = ({clientX, clientY, currentTarget}) => {
  const bounds = currentTarget.getBoundingClientRect();

  return {
    x: clientX - bounds.left,
    y: clientY - bounds.top,
  };
};
